import p1 from "./portfolio1.png";
import p2 from "./portfolio2.png";
import p3 from "./portfolio3.png";
import p4 from "./portfolio4.png";
import p5 from "./portfolio5.png";
import p6 from "./portfolio6.png";
import p7 from "./portfolio7.png";
import p8 from "./portfolio8.png";
import p9 from "./portfolio9.png";
import p10 from "./portfolio10.png";
import p11 from "./portfolio11.png";

export const projectData = [
  {
    id: 1,
    name: "Employee CRUD management",
    info: " Javascript, React.js, Node.js, Mongoose, Redux toolkit",
    gitLink: "https://github.com/ZoranUTF8/react-bootstrap-website",
    demoLink: "https://react-bootstrap-website-zoran-janjic.netlify.app/",
    imgPath: p1,
  },
  {
    id: 2,
    name: "Job tracking",
    info: "Javascript, React.js, Node.js, Mongoose",
    gitLink: "https://github.com/ZoranUTF8/noviPosao_MERN",
    demoLink: "https://newjob.onrender.com/",
    imgPath: p2,
  },
  {
    id: 3,
    name: "Movie search Javascript",
    info: "Javascript, TMBD api.",
    gitLink: "https://github.com/ZoranUTF8/movieSearchjs",
    demoLink: "https://friendly-snyder-3b6120.netlify.app/",
    imgPath: p3,
  },
  {
    id: 4,
    name: "Movie search",
    info: "Javascript, React.js, TMBD api.",
    gitLink: "https://github.com/ZoranUTF8/movieDB_react",
    demoLink: "https://search-moviedb-react.netlify.app/",
    imgPath: p4,
  },
  {
    id: 5,
    name: "Weather forecast",
    info: "Javascript, Openweathermap api.",
    gitLink: "https://github.com/ZoranUTF8/WeatherApi",
    demoLink: "https://mighty-brushlands-35689.herokuapp.com/",
    imgPath: p5,
  },
  {
    id: 6,
    name: "Restaurant website",
    info: "Javascript, Bootstrap.",
    gitLink: "https://github.com/ZoranUTF8/fabrika_ukusa_webPage",
    demoLink: "https://zoranutf8.github.io/fabrika_ukusa_webPage/index.html",
    imgPath: p6,
  },
  {
    id: 7,
    name: "Clinic Managements System",
    info: "Java, MySql RDBMS",
    gitLink: "https://github.com/ZoranUTF8/Clinic_Management_System",
    demoLink: null,
    imgPath: p7,
  },
  {
    id: 8,
    name: "RESTful api",
    info: "Javascript, Node.js",
    gitLink: "https://github.com/ZoranUTF8/RESTapi_example",
    demoLink: "https://restapi-example.onrender.com/",
    imgPath: p8,
  },
  {
    id: 9,
    name: "QR code generator",
    info: "Javascript, React.js",
    gitLink: "https://github.com/ZoranUTF8/MojQR",
    demoLink: "https://mojqrkod.netlify.app/",
    imgPath: p9,
  },
  {
    id: 10,
    name: "Light/Dark theme switch",
    info: "Javascript, React.js",
    gitLink: "https://github.com/ZoranUTF8/react_theme_switch",
    demoLink: "https://voluble-genie-253898.netlify.app/",
    imgPath: p10,
  },
  {
    id: 11,
    name: "Meme generator",
    info: "Javascript, React.js",
    gitLink: "https://github.com/ZoranUTF8/react_meme_generator",
    demoLink: "https://meme-generator23.netlify.app/",
    imgPath: p11,
  },
];
